var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value > 0)?_c('a',{attrs:{"href":"javascript: void(0);"},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(" "+_vm._s(_vm.padLeft(_vm.value))+" "),_c('i',{staticClass:"fe-eye icon-blue ml-1"})]):_c('div',[_vm._v(" "+_vm._s(_vm.padLeft(_vm.value))+" "),_c('i',{staticClass:"fe-eye-off ml-1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }